<template>
 <div class="dataContent">
    <div class="dataTitle">
      片区提交数据排名<span class="dataTitleTips">（排名实时生成）</span>
      <a-space style="float: right;margin-right: 20px;">
        <span class="timeStr" :class="timeType === 'today' ? 'selectColor' : ''" @click="() => selectTime('today')">今日</span>
        <span class="timeStr" :class="timeType === 'week' ? 'selectColor' : ''" @click="() => selectTime('week')">本周</span>
        <span class="timeStr" :class="timeType === 'month' ? 'selectColor' : ''" @click="() => selectTime('month')">本月</span>
        <span class="timeStr" :class="timeType === 'year' ? 'selectColor' : ''" @click="() => selectTime('year')">全年</span>
        <a-range-picker v-model="dateRange" />
      </a-space>
    </div>
    <div>
      <div style="width: 75%;float: left;">
        <h3 style="margin: 10px 0;font-weight: bold;padding-left: 20px;">TOP10片区</h3>
        <Echarts :xAxisData="xAxisData" :seriesData="seriesData" :eachartsRefresh="eachartsRefresh" />
      </div>
      <div style="width: 25%;float: left;">
        <h3 style="margin: 10px 0;font-weight: bold;">各片区详情</h3>
        <a-list style="max-height: 400px;overflow-y: auto;" class="listRow" item-layout="horizontal" :data-source="list">
          <a-list-item slot="renderItem" slot-scope="item,i">
            <a-list-item-meta>
              <a-row slot="title">
                <a-col :span="3"><span class="sortContent" :class="i > 2 ? 'bg2' : 'bg1'">{{ i + 1 }}</span></a-col>
                <a-col :span="9" style="line-height: 24px;">{{ item.settlementName }}</a-col>
                <a-col :span="9" style="line-height: 24px;">{{ item.num || item.num === 0 ? Number(item.num).toFixed(0) : item.num }}</a-col>
                <a-col :span="3" style="line-height: 24px;"><a @click="() => sortDetail(item)">详情</a></a-col>
              </a-row>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
      <div style="clear: both;"></div>
    </div>
    <SortDetailModal :dateRange="dateRange" />
 </div>
</template>

<script>
import moment from 'moment'
import api from '../api'
import {columnsPig} from '../Columns'
import Echarts from './CommonConponents/Echarts.vue';
import SortDetailModal from './PigAnalysisModal/SortDetailModal';
import { mapMutations } from 'vuex';
export default {
  components: {
    Echarts,SortDetailModal
  },
  props: [],
  data() {
    return {
      columns: columnsPig,
      list: [],
      timeType: 'today',
      dateRange: [moment(new Date()),moment(new Date())],
      xAxisData: [],
      seriesData: [],
      eachartsRefresh: 0
    }
  },
  watch: {
    dateRange: {
      handler(){
        setTimeout(() => {
          this.getList()
        }, 0);
      },
      deep: true,
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.selectTime('month')
    setTimeout(() => {
      this.getList()
    }, 0);
  },
  methods: {
    ...mapMutations('empirical',['setState']),
    sortDetail(sortRow){
      this.setState({sortDetailVisible: true,sortRow})
    },
    async getList(){
      // let {current=1,pageSize=20} = pagination || this.pagination
      let time = this.dateRange
      let params = {
        startTime: time && time.length > 0 ? moment(time[0]).format('YYYY-MM-DD 00:00:00') : undefined,
        endTime: time && time.length > 0 ? moment(time[1]).format('YYYY-MM-DD 23:59:59') : undefined,
      }
      let res = await api.settlementRank(params)
      let {success,data = []} = res || {}
      if(success){
        this.list = JSON.parse(JSON.stringify(data)) || []
        let lst = data.splice(0,10) || []
        this.xAxisData = lst.map(el => el.settlementName)
        this.seriesData = lst.map(el => el.num)
        this.eachartsRefresh = this.eachartsRefresh + 1
      }
    },
    selectTime(timeType){
      this.timeType = timeType
      let oneDay = 1000 * 60 * 60 * 24
      let d = new Date()
      if(timeType === 'today'){
        this.dateRange = [moment(new Date()),moment(new Date())]
      }else if(timeType === 'week'){
        let t = d.getTime()
        let num = d.getDay()
        if(d === 0) d = 7
        this.dateRange = [moment(new Date(t - ((num - 1) * oneDay))),moment(new Date(t + ((7 - num) * oneDay)))]
      }else if(timeType === 'month'){
        let first = new Date(`${d.getFullYear()}-${d.getMonth() + 1}-01`)
        let last = new Date(d.getFullYear(), d.getMonth() + 1, 0)
        this.dateRange = [moment(first),moment(last)]
      }else if(timeType === 'year'){
        let first = new Date(`${d.getFullYear()}-01-01`)
        let last = new Date(`${d.getFullYear()}-12-31`)
        this.dateRange = [moment(first),moment(last)]
      }
    },
  },
}
</script>
<style lang='scss'>
.listRow{
  .ant-list-item{
    padding: 7px 0;
    border: none;
  }
}
</style>
<style lang='scss' scoped>
.sortContent{
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 24px;
  line-height: 24px;
  text-align: center;
  color: #fff;
}
.bg1{
  background: #000;
}
.bg2{
  background: #666;
}
.timeStr{
  color: #333;
  cursor: pointer;
  font-weight: normal;
  font-size: 14px;
}
.selectColor{
  color: #1677FF;
}

</style>